module.exports = __webpack_public_path__ + "img/abc.1e8daaf5.jpg";